import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  ICreateWorkspaceUsersPayload,
  IDeleteWorkspaceUserPayload,
} from '@SiteModules/WorkspaceUser/types'

const config: AxiosRequestConfig = {
  responseType: 'json'
}

export function createWorkspaceUsers(payload: ICreateWorkspaceUsersPayload) {
  return axios.post(`/api/v1/account_users/create_workspace_users/`, convertToSnakeCase(payload), config)
}

export function deleteWorkspaceUser(payload: IDeleteWorkspaceUserPayload) {
  return axios.delete(`/api/v1/workspace_users/${payload.workspaceUserId}`, config)
}
